import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { FeatureFlag, UpdateFeatureFlagInput } from "./types";
import { FEATURE_FLAGS_LIST_QUERY_KEY } from "./use-feature-flags-list";
import { FEATURE_FLAG_DETAIL_QUERY_KEY } from "./use-feature-flag-detail";
import { FEATURE_FLAG_HISTORY_QUERY_KEY } from "./use-feature-flag-history";

interface UpdateParams {
  readonly id: string;
  readonly input: UpdateFeatureFlagInput;
}

async function updateFeatureFlag({ id, input }: UpdateParams): Promise<FeatureFlag> {
  return httpClient<FeatureFlag>(`/api/admin/feature-flags/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function useUpdateFeatureFlag() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateFeatureFlag,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FEATURE_FLAGS_LIST_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: FEATURE_FLAG_DETAIL_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: FEATURE_FLAG_HISTORY_QUERY_KEY });
    },
  });
}
